import axios from 'axios';
import getBaseUrl from '../../../shared/utils/Host';

const BaseUrl = getBaseUrl();
const API_URL = `${BaseUrl}product`;

export const searchProductCategory = (param) => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL}/search-product-category/${param}`, {
    headers: {
        'Content-Type': 'application/json',  // Indicates the format of the request data
        'Accept': 'application/json',
        Authorization: `Bearer ${token}`, // Send token in Authorization header
    },
});}

export const countCategories = () => axios.get(`${API_URL}/product/count-category`);
